
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */
// biome-ignore-all lint: generated file

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  DbNull,
  JsonNull,
  AnyNull,
  NullTypes,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 7.9.0
 * Query Engine version: e922089b7d7502aff4249d5da3420f6fa55fc6ad
 */
Prisma.prismaVersion = {
  client: "7.9.0",
  engine: "e922089b7d7502aff4249d5da3420f6fa55fc6ad"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = DbNull
Prisma.JsonNull = JsonNull
Prisma.AnyNull = AnyNull

Prisma.NullTypes = NullTypes



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ChatScalarFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  description: 'description',
  status: 'status',
  lastUpdate: 'lastUpdate',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  adminReadAt: 'adminReadAt',
  type: 'type',
  courseId: 'courseId',
  courseType: 'courseType',
  caseNumber: 'caseNumber',
  pinned: 'pinned',
  lastMessageSeq: 'lastMessageSeq',
  capabilities: 'capabilities'
};

exports.Prisma.AddressBookEntryScalarFieldEnum = {
  ownerId: 'ownerId',
  contactId: 'contactId',
  createdAt: 'createdAt'
};

exports.Prisma.ChatInviteScalarFieldEnum = {
  token: 'token',
  issuerId: 'issuerId',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  redeemedById: 'redeemedById',
  redeemedAt: 'redeemedAt',
  chatId: 'chatId'
};

exports.Prisma.ChatMembershipScalarFieldEnum = {
  userId: 'userId',
  chatId: 'chatId',
  hasDeleted: 'hasDeleted',
  lastReadSeq: 'lastReadSeq',
  lastReadMessageId: 'lastReadMessageId',
  chatPermission: 'chatPermission',
  pinnedAt: 'pinnedAt',
  mutedAt: 'mutedAt',
  markedUnread: 'markedUnread'
};

exports.Prisma.MessageScalarFieldEnum = {
  uuid: 'uuid',
  type: 'type',
  createdAt: 'createdAt',
  seq: 'seq',
  chatId: 'chatId',
  senderId: 'senderId',
  parentId: 'parentId',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById'
};

exports.Prisma.MessageContentScalarFieldEnum = {
  uuid: 'uuid',
  revision: 'revision',
  payload: 'payload',
  messageId: 'messageId'
};

exports.Prisma.MessageEventScalarFieldEnum = {
  uuid: 'uuid',
  type: 'type',
  messageId: 'messageId',
  userId: 'userId',
  messageContentId: 'messageContentId'
};

exports.Prisma.MessageReactionScalarFieldEnum = {
  uuid: 'uuid',
  emoji: 'emoji',
  createdAt: 'createdAt',
  messageId: 'messageId',
  userId: 'userId'
};

exports.Prisma.DocumentDownloadScalarFieldEnum = {
  id: 'id',
  documentId: 'documentId',
  userId: 'userId',
  locale: 'locale',
  downloadedAt: 'downloadedAt'
};

exports.Prisma.MaterialCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  sortOrder: 'sortOrder'
};

exports.Prisma.MaterialItemScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  description: 'description',
  usageNotes: 'usageNotes',
  returnInstructions: 'returnInstructions',
  imageUrl: 'imageUrl',
  unit: 'unit',
  categoryId: 'categoryId',
  totalQuantity: 'totalQuantity',
  maxLoanQuantity: 'maxLoanQuantity',
  orderStep: 'orderStep',
  damagedQuantity: 'damagedQuantity',
  inRepairQuantity: 'inRepairQuantity',
  lowStockThreshold: 'lowStockThreshold',
  isConsumable: 'isConsumable',
  isReservable: 'isReservable',
  isDisabled: 'isDisabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MaterialLoanScalarFieldEnum = {
  id: 'id',
  number: 'number',
  itemId: 'itemId',
  quantity: 'quantity',
  hofId: 'hofId',
  personId: 'personId',
  responsibleName: 'responsibleName',
  comment: 'comment',
  startDate: 'startDate',
  endDate: 'endDate',
  isConsumption: 'isConsumption',
  status: 'status',
  issuedQuantity: 'issuedQuantity',
  issuedAt: 'issuedAt',
  returnAnnouncedAt: 'returnAnnouncedAt',
  returnedQuantity: 'returnedQuantity',
  returnedAt: 'returnedAt',
  returnCondition: 'returnCondition',
  returnNote: 'returnNote',
  rejectionReason: 'rejectionReason',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MaterialIncidentScalarFieldEnum = {
  id: 'id',
  itemId: 'itemId',
  loanId: 'loanId',
  condition: 'condition',
  quantity: 'quantity',
  note: 'note',
  photoKey: 'photoKey',
  reportedById: 'reportedById',
  resolvedAt: 'resolvedAt',
  createdAt: 'createdAt'
};

exports.Prisma.PhotoContestScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  description: 'description',
  status: 'status',
  votingStart: 'votingStart',
  votingEnd: 'votingEnd',
  maxPointsPerUser: 'maxPointsPerUser',
  maxPointsPerImage: 'maxPointsPerImage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PhotoContestImageScalarFieldEnum = {
  id: 'id',
  contestId: 'contestId',
  imageUrl: 'imageUrl',
  thumbnailUrl: 'thumbnailUrl',
  title: 'title',
  description: 'description',
  uploadedById: 'uploadedById',
  order: 'order',
  createdAt: 'createdAt'
};

exports.Prisma.PhotoContestVoteScalarFieldEnum = {
  id: 'id',
  contestId: 'contestId',
  imageId: 'imageId',
  userId: 'userId',
  points: 'points',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PushNotificationLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  content: 'content',
  sentAt: 'sentAt',
  deliveredAt: 'deliveredAt',
  interactedAt: 'interactedAt',
  interactionType: 'interactionType',
  userAgent: 'userAgent',
  channel: 'channel',
  status: 'status',
  error: 'error',
  kind: 'kind',
  notificationId: 'notificationId',
  subscriptionId: 'subscriptionId',
  priority: 'priority',
  attempts: 'attempts',
  nextAttemptAt: 'nextAttemptAt',
  leaseUntil: 'leaseUntil'
};

exports.Prisma.PushNotificationScalarFieldEnum = {
  id: 'id',
  kind: 'kind',
  title: 'title',
  body: 'body',
  url: 'url',
  chatId: 'chatId',
  messageId: 'messageId',
  notificationType: 'notificationType',
  ignoreIfUrlMatches: 'ignoreIfUrlMatches',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  completedAt: 'completedAt'
};

exports.Prisma.EnrollmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  courseId: 'courseId',
  courseType: 'courseType'
};

exports.Prisma.StarScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  courseId: 'courseId',
  courseType: 'courseType',
  createdAt: 'createdAt'
};

exports.Prisma.ScheduleReminderScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  entryId: 'entryId',
  entryType: 'entryType',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScheduleReminderDeliveryScalarFieldEnum = {
  userId: 'userId',
  entryId: 'entryId',
  kind: 'kind',
  scheduledFor: 'scheduledFor',
  sentAt: 'sentAt'
};

exports.Prisma.UserScalarFieldEnum = {
  uuid: 'uuid',
  lastSeen: 'lastSeen',
  name: 'name',
  description: 'description',
  hidden: 'hidden',
  testAccount: 'testAccount',
  presentAtCamp: 'presentAtCamp',
  hofIds: 'hofIds',
  avpHofIds: 'avpHofIds',
  funktionIds: 'funktionIds',
  profilePictureVersion: 'profilePictureVersion',
  reminderLeadMinutes: 'reminderLeadMinutes',
  reminderAtStart: 'reminderAtStart',
  reminderLocale: 'reminderLocale'
};

exports.Prisma.PresenceLogScalarFieldEnum = {
  uuid: 'uuid',
  userUuid: 'userUuid',
  isPresent: 'isPresent',
  timestamp: 'timestamp'
};

exports.Prisma.VisitDayRegistrationScalarFieldEnum = {
  id: 'id',
  number: 'number',
  hofId: 'hofId',
  counter: 'counter',
  withLunch: 'withLunch',
  submissionId: 'submissionId',
  billNumber: 'billNumber',
  visitDate: 'visitDate',
  createdAt: 'createdAt'
};

exports.Prisma.VisitDayVisitorScalarFieldEnum = {
  id: 'id',
  registrationId: 'registrationId',
  personNumber: 'personNumber',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.ChatStatus = exports.$Enums.ChatStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
};

exports.ChatType = exports.$Enums.ChatType = {
  ONE_TO_ONE: 'ONE_TO_ONE',
  GROUP: 'GROUP',
  EMERGENCY: 'EMERGENCY',
  SUPPORT_GROUP: 'SUPPORT_GROUP',
  COURSE_GROUP: 'COURSE_GROUP',
  ANNOUNCEMENT: 'ANNOUNCEMENT'
};

exports.CourseType = exports.$Enums.CourseType = {
  PROGRAM: 'PROGRAM',
  SHIFT: 'SHIFT'
};

exports.ChatCapability = exports.$Enums.ChatCapability = {
  CAN_SEND_MESSAGES: 'CAN_SEND_MESSAGES',
  PICTURE_UPLOAD: 'PICTURE_UPLOAD',
  THREADS: 'THREADS',
  THREAD_REPLIES: 'THREAD_REPLIES',
  EMOJI_REACTIONS: 'EMOJI_REACTIONS'
};

exports.ChatMembershipPermission = exports.$Enums.ChatMembershipPermission = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  GUEST: 'GUEST'
};

exports.MessageType = exports.$Enums.MessageType = {
  SYSTEM_MSG: 'SYSTEM_MSG',
  TEXT_MSG: 'TEXT_MSG',
  LOCATION_MSG: 'LOCATION_MSG',
  IMAGE_MSG: 'IMAGE_MSG',
  ALERT_QUESTION: 'ALERT_QUESTION',
  ALERT_RESPONSE: 'ALERT_RESPONSE'
};

exports.MessageEventType = exports.$Enums.MessageEventType = {
  CREATED: 'CREATED',
  STORED: 'STORED',
  DISTRIBUTED: 'DISTRIBUTED',
  RECEIVED: 'RECEIVED',
  READ: 'READ'
};

exports.MaterialLoanStatus = exports.$Enums.MaterialLoanStatus = {
  REQUESTED: 'REQUESTED',
  RESERVED: 'RESERVED',
  ISSUED: 'ISSUED',
  RETURNED: 'RETURNED',
  CONSUMED: 'CONSUMED',
  CANCELLED: 'CANCELLED'
};

exports.MaterialCondition = exports.$Enums.MaterialCondition = {
  OK: 'OK',
  LIGHT_DAMAGE: 'LIGHT_DAMAGE',
  DAMAGED: 'DAMAGED',
  MISSING: 'MISSING'
};

exports.PhotoContestStatus = exports.$Enums.PhotoContestStatus = {
  HIDDEN: 'HIDDEN',
  ACTIVE: 'ACTIVE',
  CLOSED_HIDDEN: 'CLOSED_HIDDEN',
  CLOSED: 'CLOSED'
};

exports.PushNotificationChannel = exports.$Enums.PushNotificationChannel = {
  WEB_PUSH: 'WEB_PUSH',
  NATIVE_FCM: 'NATIVE_FCM'
};

exports.PushNotificationStatus = exports.$Enums.PushNotificationStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED'
};

exports.PushNotificationKind = exports.$Enums.PushNotificationKind = {
  CHAT: 'CHAT',
  EMERGENCY: 'EMERGENCY',
  SUPPORT: 'SUPPORT',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  SYSTEM: 'SYSTEM',
  REMINDER: 'REMINDER'
};

exports.ScheduleReminderDeliveryKind = exports.$Enums.ScheduleReminderDeliveryKind = {
  LEAD: 'LEAD',
  START: 'START'
};

exports.Prisma.ModelName = {
  Chat: 'Chat',
  AddressBookEntry: 'AddressBookEntry',
  ChatInvite: 'ChatInvite',
  ChatMembership: 'ChatMembership',
  Message: 'Message',
  MessageContent: 'MessageContent',
  MessageEvent: 'MessageEvent',
  MessageReaction: 'MessageReaction',
  DocumentDownload: 'DocumentDownload',
  MaterialCategory: 'MaterialCategory',
  MaterialItem: 'MaterialItem',
  MaterialLoan: 'MaterialLoan',
  MaterialIncident: 'MaterialIncident',
  PhotoContest: 'PhotoContest',
  PhotoContestImage: 'PhotoContestImage',
  PhotoContestVote: 'PhotoContestVote',
  PushNotificationLog: 'PushNotificationLog',
  PushNotification: 'PushNotification',
  Enrollment: 'Enrollment',
  Star: 'Star',
  ScheduleReminder: 'ScheduleReminder',
  ScheduleReminderDelivery: 'ScheduleReminderDelivery',
  User: 'User',
  PresenceLog: 'PresenceLog',
  VisitDayRegistration: 'VisitDayRegistration',
  VisitDayVisitor: 'VisitDayVisitor'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
